var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"minimized-modals-container"},[_c('transition-group',{attrs:{"name":"slide-fade","tag":"div"}},_vm._l((_vm.value),function(modal){return _c('minimized-modal',_vm._b({key:modal.name,on:{"click":function($event){return _vm.handleClick(modal)}}},'minimized-modal',_vm.value,false))}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }